<button
    class="bg-transparent border-0 flex items-center gap-0 cursor-pointer"
    id="change-status"
    data-testid="details-header-button-change-status"
>
    <sh-text>{{ 'common.request-detail.change-status' | translate }}</sh-text>
    <sh-icon icon="arrow-line-down-s"></sh-icon>
</button>
<sh-popover target="change-status" position="bottom">
    @if (request().status === states.SUBMITTED) {
        <sh-menu-item
            data-testid="details-status-menu-option-assign-to"
            [toggle]="false"
            label="{{ 'common.request-detail.assign-to' | translate }}"
            (click)="handleAssignTo()"
        >
        </sh-menu-item>
    }
    @if (canPutOnHold()) {
        <sh-menu-item
            data-testid="details-status-menu-option-put-on-hold"
            [toggle]="false"
            label="{{ 'common.put-request-on-hold-dialog.title' | translate }}"
            (click)="handlePutRequestOnHoldDialog()"
        >
        </sh-menu-item>
    }
    @if (canSetActive()) {
        <sh-menu-item
            data-testid="details-status-menu-option-set-active"
            [toggle]="false"
            label="{{ 'common.set-request-active-dialog.title' | translate }}"
            (click)="handleOpenSetRequestActiveDialog()"
        >
        </sh-menu-item>
    }
    @if (canShowUnderReviewButton()) {
        <sh-menu-item
            data-testid="details-status-menu-option-assign-request"
            [toggle]="false"
            label="{{ 'common.request-detail.assign' | translate }}"
            (click)="handleAsignRequest()"
        >
        </sh-menu-item>
    }
    @if (canReassign()) {
        <sh-menu-item
            data-testid="details-status-menu-option-reassign"
            [toggle]="false"
            label="{{ 'common.reassign-request-dialog.title' | translate }}"
            (click)="handleOpenReassignRequestDialog()"
        >
        </sh-menu-item>
    }
    @if (canShowPendingCustomerActionButton()) {
        <sh-menu-item
            data-testid="details-status-menu-option-request-feedback"
            [toggle]="false"
            label="{{ 'common.demand-feedback-dialog.title' | translate }}"
            (click)="handleOpenDemandCustomerFeedbackDialog()"
        >
        </sh-menu-item>
    }
    @if (canShowReferredOutButton()) {
        <sh-menu-item
            data-testid="details-status-menu-option-refer-out-email"
            [toggle]="false"
            label="{{ 'common.request-detail.refer-out-external' | translate }}"
            (click)="handleOpenExternalReferOutDialog()"
        >
        </sh-menu-item>
        <sh-menu-item
            data-testid="details-status-menu-option-refer-out-mdla-team"
            [toggle]="false"
            label="{{ 'common.request-detail.refer-out-internal' | translate }}"
            (click)="handleOpenInternalReferOutDialog()"
        >
        </sh-menu-item>
    }
    @if (canShowClosedButton()) {
        <sh-menu-item
            data-testid="details-status-menu-option-mark-resolved"
            [toggle]="false"
            label="{{ 'common.request-detail.mark-request-resolved' | translate }}"
            (click)="handleOpenCloseRequestDialog()"
        >
        </sh-menu-item>
    }
</sh-popover>
